import {
  Droplets, Droplet, Bath, Utensils, ShowerHead, Waves, Thermometer, Flame, Ruler,
} from "lucide-react";

export const COMPANY = {
  name: "Aqua Control Plumbing",
  tagline: "All your plumbing, hydronics and drain under control.",
  phone: "647-801-8502",
  phoneHref: "tel:+16478018502",
  email: "Plumbing.aquacontrol@gmail.com",
  emailHref: "mailto:Plumbing.aquacontrol@gmail.com",
  addressLine1: "919 Streamway Cres",
  addressLine2: "Mississauga, ON L4Y 2P3",
  country: "Canada",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_36f07a14-fbfd-40ed-beed-64eab2ff40a0/artifacts/6t3e8zav_6293FFDD-A412-4772-9D14-9E4BEFA0A696.png",
  icon: "/aqua-icon.png",
  whatsappHref: "https://wa.me/16478018502?text=Hi%20Aqua%20Control%20Plumbing%2C%20I%27d%20like%20to%20ask%20about%20a%20plumbing%20service.",
  googleReviewsHref: "https://www.google.com/maps/search/?api=1&query=Aqua+Control+Plumbing+Mississauga",
};

export const SERVICES = [
  { id: "toilets", title: "Toilets", icon: Droplets, blurb: "Repairs, replacements & running-toilet fixes done right.", span: "md:col-span-2" },
  { id: "faucets", title: "Faucets", icon: Droplet, blurb: "Drips, leaks and sleek new fixture installs." },
  { id: "tubs", title: "Tubs", icon: Bath, blurb: "Soaker & standard tub install and repair." },
  { id: "dishwashers", title: "Dishwashers", icon: Utensils, blurb: "Clean hook-ups, no leaks, no guesswork." },
  { id: "showers", title: "Showers", icon: ShowerHead, blurb: "Valves, heads and full shower plumbing.", span: "md:col-span-2" },
  { id: "bidets", title: "Bidets", icon: Waves, blurb: "Modern bidet supply lines & installation." },
  { id: "hydronics", title: "Hydronics", icon: Thermometer, blurb: "Radiant & boiler heating, balanced and efficient.", span: "md:col-span-2" },
  { id: "water-heaters", title: "Water Heaters", icon: Flame, blurb: "Tank & tankless — hot water when you need it." },
  { id: "rough-in", title: "Rough-In", icon: Ruler, blurb: "New-build & renovation rough-in piping, done to code.", span: "md:col-span-2" },
];

export const GUARANTEES = [
  "Licensed",
  "Fully Insured",
  "24/7 Emergency",
  "GTA-Wide",
  "Upfront Pricing",
];

export const MANIFESTO = [
  { no: "01", title: "Precision", body: "Every joint, valve and line installed to code and to last. We treat your home like an engineering problem worth solving perfectly." },
  { no: "02", title: "Reliability", body: "One trusted plumber, start to finish. No rotating crews, no surprises — just clean, dependable work you can point to for years." },
  { no: "03", title: "On Call", body: "Burst pipe at 2am? Backed-up drain before guests arrive? We answer, we show up, and we control the situation fast." },
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    location: "Mississauga, ON",
    quote: "Fixed a leaking shower valve the same day I called. Clean, on-time and explained everything. Finally a plumber I trust.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjdXN0b21lciUyMHBvcnRyYWl0JTIwaGVhZHNob3QlMjBzbWlsaW5nfGVufDB8fHx8MTc4NjA2MzQyM3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "David R.",
    location: "Toronto, ON",
    quote: "Installed a tankless water heater and re-did our hydronic loop. Upfront pricing, no games. The workmanship is spotless.",
    avatar: "https://images.unsplash.com/photo-1633625510483-c177f4308f33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxjdXN0b21lciUyMHBvcnRyYWl0JTIwaGVhZHNob3QlMjBzbWlsaW5nfGVufDB8fHx8MTc4NjA2MzQyM3ww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Priya K.",
    location: "Brampton, ON",
    quote: "Emergency call on a Sunday — answered right away and had our burst pipe under control within the hour. Lifesaver.",
    avatar: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxjdXN0b21lciUyMHBvcnRyYWl0JTIwaGVhZHNob3QlMjBzbWlsaW5nfGVufDB8fHx8MTc4NjA2MzQyM3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const PROJECTS = [
  {
    id: "toilet-install",
    title: "Toilet Installation",
    location: "Mississauga, ON",
    blurb: "Removed a worn-out, corroded flange and installed a brand-new toilet — clean, solid and leak-free.",
    before: "https://customer-assets-gfyr7b9c.emergentagent.net/job_aqua-home-plumb/artifacts/s7eaf1dg_IMG_0944.webp",
    after: "https://customer-assets-gfyr7b9c.emergentagent.net/job_aqua-home-plumb/artifacts/vx26evrs_IMG_0946.jpeg",
  },
  {
    id: "freestanding-tub",
    title: "Freestanding Tub & Faucet Install",
    location: "Toronto, ON",
    blurb: "Set and levelled a freestanding tub and installed a sleek floor-mounted faucet in a Toronto new build.",
    before: "https://customer-assets-gfyr7b9c.emergentagent.net/job_aqua-home-plumb/artifacts/3y99tfr8_IMG_0959.jpeg",
    after: "https://customer-assets-gfyr7b9c.emergentagent.net/job_aqua-home-plumb/artifacts/6jcu9keq_IMG_0960.jpeg",
  },
  {
    id: "water-line-drain",
    title: "Water Line & Drain Excavation",
    location: "Greater Toronto Area",
    blurb: "Excavated and safely shored a trench, then ran a new underground water line and drain — connected and inspected to code.",
    before: "https://customer-assets-gfyr7b9c.emergentagent.net/job_aqua-home-plumb/artifacts/ox8pm80d_IMG_1031.jpeg",
    after: "https://customer-assets-gfyr7b9c.emergentagent.net/job_aqua-home-plumb/artifacts/7oeaftuk_IMG_1032.jpeg",
  },
  {
    id: "bathroom-reno",
    title: "Full Bathroom Renovation",
    location: "Mississauga, ON",
    blurb: "Gutted a dated, worn-out bathroom and re-plumbed it into a bright, modern space.",
    before: "https://images.unsplash.com/photo-1754212536450-1b3591a3b837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxvdXRkYXRlZCUyMG9sZCUyMGJhdGhyb29tJTIwYmVmb3JlJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3ODYxMTQ5OTF8MA&ixlib=rb-4.1.0&q=85",
    after: "https://images.unsplash.com/photo-1682888818696-906287d759f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxyZW5vdmF0ZWQlMjBtb2Rlcm4lMjBiYXRocm9vbSUyMHZhbml0eSUyMHNpbmt8ZW58MHx8fHwxNzg2MTE0OTkxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "kitchen-reno",
    title: "Kitchen Sink & Faucet Reno",
    location: "Toronto, ON",
    blurb: "Tore out a tired, dated kitchen and rebuilt it around a clean new sink and faucet.",
    before: "https://images.unsplash.com/photo-1705538851801-4de1c763df2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxkYXRlZCUyMG9sZCUyMGtpdGNoZW4lMjBiZWZvcmUlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc4NjExNTM1MXww&ixlib=rb-4.1.0&q=85",
    after: "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjByZW5vdmF0ZWQlMjBraXRjaGVuJTIwc2luayUyMGNvdW50ZXJ8ZW58MHx8fHwxNzg2MTE1MzUxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "bathroom-remodel",
    title: "Bathroom Shower Remodel",
    location: "Oakville, ON",
    blurb: "Replaced a dated, worn-out bathroom with a bright, fully re-plumbed space.",
    before: "https://images.unsplash.com/photo-1562606795-905ad4a92a67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxvdXRkYXRlZCUyMG9sZCUyMGJhdGhyb29tJTIwYmVmb3JlJTIwcmVub3ZhdGlvbnxlbnwwfHx8fDE3ODYxMTQ5OTF8MA&ixlib=rb-4.1.0&q=85",
    after: "https://images.unsplash.com/photo-1609946860441-a51ffcf22208?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjByZW5vdmF0ZWQlMjBiYXRocm9vbSUyMHNob3dlciUyMHRpbGVzfGVufDB8fHx8MTc4NjExNTM1MXww&ixlib=rb-4.1.0&q=85",
  },
];

export const SERVICE_AREAS = [
  "Mississauga", "Toronto", "Brampton", "Oakville", "Etobicoke", "Vaughan",
  "Milton", "Burlington", "Markham", "Richmond Hill", "Caledon", "Halton Hills",
];
